/* AcrylArtistry — sepet cekmecesindeki "Mini tabela ekle" karti.
   Cekmece her guncellemede innerHTML ile yeniden ciziliyor, bu yuzden
   dinleyici DOKUMAN seviyesinde delege edilir (kart icine <script> koymak
   ise yaramaz: innerHTML ile eklenen script calismaz).

   Mini ARTIK PROPERTY'SIZ EKLENMEZ: tasarimi, kartin isaret ettigi ana tabela
   kaleminden (data-acr-dbump-src = line key) kopyalanir. Ortak mantik
   assets/acr-mini-props.js icinde; iki ekleme yolu da onu kullanir. */
(function () {
  'use strict';

  function addUrlFallback() {
    var u = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return /\.js$/.test(u) ? u : u + '.js';
  }

  function sectionHTML(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function repaint(sections) {
    if (window.AcrMiniProps) { window.AcrMiniProps.repaint(sections); return; }
    if (!sections) return;
    var drawer = sections['cart-drawer'];
    if (drawer) {
      var cur = document.querySelector('#CartDrawer .drawer__inner');
      var fresh = sectionHTML(drawer, '.drawer__inner');
      if (cur && fresh !== null) cur.innerHTML = fresh;
    }
    var bubble = sections['cart-icon-bubble'];
    if (bubble) {
      var cb = document.getElementById('cart-icon-bubble');
      var fb = sectionHTML(bubble, '.shopify-section');
      if (cb && fb !== null) cb.innerHTML = fb;
    }
  }

  /* ---------- mini tasarimcisi: cekmecenin USTUNDE acilan katman ----------
     Shopify magaza sayfalarini iframe'e sokmuyor (x-frame-options: DENY),
     bu yuzden tasarimci bolumunu Section Rendering API ile cekip gomuyoruz.
     innerHTML ile gelen <script> CALISMAZ -> her birini yeni script dugumune
     kopyalayip calistiriyoruz. Bolum, window.__ACR_MINI_BUMP'i gorunce
     cekmece moduna geciyor ve isi bitince 'acr:mini-bump-done' atiyor. */
  var MINI_SECTION = '/products/mini-qr-code-sign?section_id=acr-mini-configurator';
  var overlay = null;

  function runScripts(scope) {
    var list = [].slice.call(scope.querySelectorAll('script'));
    list.forEach(function (s) {
      var n = document.createElement('script');
      if (s.src) { n.src = s.src; } else { n.textContent = s.textContent; }
      s.parentNode.replaceChild(n, s);
    });
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    try { delete window.__ACR_MINI_BUMP; } catch (e) { window.__ACR_MINI_BUMP = null; }
    document.documentElement.classList.remove('acr-mcov-open');
  }

  function refreshCartSections() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(function (data) { repaint(data); })
      .catch(function () { window.location.reload(); });
  }

  function openDesigner(opts) {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'acr-mcov';
    overlay.innerHTML =
      '<div class="acr-mcov__bar">'
      + '<span class="acr-mcov__title">' + (opts.editing ? 'Change your mini' : 'Design your mini') + '</span>'
      + '<button type="button" class="acr-mcov__x" data-acr-mcov-close aria-label="Close">&times;</button>'
      + '</div>'
      + '<div class="acr-mcov__body"><p class="acr-mcov__wait">Loading the designer…</p></div>';
    document.body.appendChild(overlay);
    document.documentElement.classList.add('acr-mcov-open');

    fetch(MINI_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!overlay) return;
        window.__ACR_MINI_BUMP = {
          variantId: opts.variantId, mainKey: opts.mainKey || '', main: opts.main || null,
          replaceKey: opts.replaceKey || '',
          priceText: opts.priceText || '', editing: !!opts.editing
        };
        var body = overlay.querySelector('.acr-mcov__body');
        body.innerHTML = html;
        runScripts(body);
        body.scrollTop = 0;
      })
      .catch(function () {
        if (!overlay) return;
        overlay.querySelector('.acr-mcov__body').innerHTML =
          '<p class="acr-mcov__wait">Couldn’t load the designer. '
          + '<a href="/products/mini-qr-code-sign">Open it on its own page →</a></p>';
      });
  }

  document.addEventListener('acr:mini-bump-done', function () {
    closeOverlay();
    refreshCartSections();
  });

  document.addEventListener('click', function (evt) {
    if (evt.target && evt.target.closest && evt.target.closest('[data-acr-mcov-close]')) {
      evt.preventDefault();
      closeOverlay();
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && overlay) closeOverlay();
  });

  /* sepetteki miniyi bastan tasarla (duzenleme panelindeki link) */
  document.addEventListener('click', function (evt) {
    var a = evt.target && evt.target.closest ? evt.target.closest('[data-acr-mini-design]') : null;
    if (!a) return;
    evt.preventDefault();
    openDesigner({
      variantId: parseInt(a.getAttribute('data-acr-mini-design'), 10),
      mainKey: a.getAttribute('data-acr-mini-mainkey') || '',
      replaceKey: a.getAttribute('data-acr-mini-key') || '',
      main: a._acrMain || null,
      editing: true
    });
  });

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('[data-acr-dbump-add]') : null;
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled) return;

    /* "Other — a different QR code" secildiyse bu dugme EKLEMEZ, tasarimciyi acar.
       Boylece tek ekleme yolu kalir; ikinci mini olusamaz. */
    if (btn.getAttribute('data-acr-design') === '1') {
      var priceEl = document.querySelector('.acr-dbump__price');
      openDesigner({
        variantId: parseInt(btn.getAttribute('data-acr-dbump-add'), 10),
        mainKey: btn.getAttribute('data-acr-dbump-src') || '',
        main: btn._acrMainLine || null,
        priceText: priceEl ? (priceEl.firstChild ? String(priceEl.firstChild.textContent || '').trim() : '') : ''
      });
      return;
    }

    var vid = parseInt(btn.getAttribute('data-acr-dbump-add'), 10);
    if (!vid) return;

    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    function fail() {
      btn.disabled = false;
      btn.innerHTML = label;
    }
    function ok(data) {
      repaint(data && data.sections);
      document.dispatchEvent(new CustomEvent('acr:cart-bump-added'));
    }

    var M = window.AcrMiniProps;
    if (!M) {
      /* Modul yuklenmediyse bile kalem BOS gitmesin: elle yedek paket. */
      fetch(addUrlFallback(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: vid, quantity: 1,
            properties: {
              'Social Media Links': 'MINI QR SIGN - order bump\nPlease make it match the big QR sign in this same order: same background colour, same text, same QR code.',
              'Design': 'Order bump - please make it match the big QR sign in this order (same colour, same QR code).',
              '_acr_bump': 'fallback-nomodule'
            }
          }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); }).then(ok).catch(fail);
      return;
    }

    var srcKey = btn.getAttribute('data-acr-dbump-src') || '';
    var qrSel = document.querySelector('[data-acr-dbump-qr]');
    var qrLink = document.querySelector('[data-acr-dbump-qrlink]');
    var qrOther = !!(qrSel && qrSel.value === 'other');
    var qrIndex = (qrSel && !qrOther) ? (parseInt(qrSel.value, 10) || 1) : 1;
    M.findMainLine(srcKey).then(function (mainLine) {
      var props;
      if (mainLine && mainLine.properties && Object.keys(mainLine.properties).length) {
        props = M.build(mainLine.properties, {
          mainKey: mainLine.key, qrIndex: qrIndex, edited: !!qrSel,
          qrOther: qrOther, qrLink: qrOther && qrLink ? qrLink.value : ''
        });
      } else {
        props = M.fallback();
      }
      return M.add(vid, props);
    }).then(ok).catch(fail);
  });

  /* ---------- cekmecedeki "Add" kartina QR secimi ----------
     Mini tek QR tasir; sepetteki tabelada 2+ QR varsa hangisinin gidecegini
     musteri SECSIN, sessizce 1. QR alinmasin. */
  function enhanceDbump() {
    var card = document.querySelector('.acr-dbump');
    if (!card || card.getAttribute('data-acr-enhanced')) return;
    var btn = card.querySelector('[data-acr-dbump-add]');
    var M = window.AcrMiniProps;
    if (!btn || !M) return;
    card.setAttribute('data-acr-enhanced', '1');
    M.findMainLine(btn.getAttribute('data-acr-dbump-src') || '').then(function (line) {
      if (!line || !line.properties) return;
      btn._acrMainLine = line;   /* tasarimci rengi/standi bundan devralir */
      var slots = M.parseSlots(line.properties);
      var wrap = document.createElement('label');
      wrap.className = 'acr-dbump__qr';
      var span = document.createElement('span');
      span.textContent = 'The mini fits one QR code — which one goes on it?';
      var sel = document.createElement('select');
      sel.setAttribute('data-acr-dbump-qr', '');
      slots.forEach(function (s) {
        var o = document.createElement('option');
        o.value = String(s.index);
        o.textContent = (slots.length > 1 ? s.index + ') ' : '') + s.name
          + (slots.length > 1 ? '' : ' (same as your sign)');
        sel.appendChild(o);
      });
      var oth = document.createElement('option');
      oth.value = 'other';
      oth.textContent = 'Other — a different QR code';
      sel.appendChild(oth);
      wrap.appendChild(span);
      wrap.appendChild(sel);
      card.appendChild(wrap);

      /* "Other" artik link kutusu DEGIL, tasarimciyi acar: musteri miniyi
         istedigi gibi kurar. Dugme de ekleme yapmaz, tasarimciya devreder —
         tek ekleme yolu kaldigi icin ikinci mini olusamaz. */
      var hint = document.createElement('p');
      hint.className = 'acr-dbump__hint';
      hint.setAttribute('data-acr-dbump-hint', '');
      hint.hidden = true;
      hint.textContent = 'You’ll design it in the next step — the colour and stand still match your sign unless you change them.';
      card.appendChild(hint);

      var addLabel = btn.textContent;
      sel.addEventListener('change', function () {
        var other = sel.value === 'other';
        hint.hidden = !other;
        btn.setAttribute('data-acr-design', other ? '1' : '0');
        btn.textContent = other ? 'Design →' : addLabel;
      });
    }, function () {});
  }

  /* ---------- sepetteki Mini kalemini degistirme ---------- */
  function miniEditor(wrap, panel, btn) {
    var M = window.AcrMiniProps;
    var key = btn.getAttribute('data-acr-mini-edit');
    panel.innerHTML = '<p class="acr-mini-edit__wait">Loading…</p>';
    panel.hidden = false;
    btn.textContent = 'Close';

    M.readCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var mini = null, main = null, i;
      for (i = 0; i < items.length; i++) { if (items[i].key === key) mini = items[i]; }
      var wantKey = mini && mini.properties ? mini.properties._acr_main_key : '';
      for (i = 0; i < items.length; i++) {
        if (wantKey && items[i].key === wantKey) { main = items[i]; break; }
        if (items[i].handle === M.MAIN_HANDLE) main = items[i];
      }
      if (!mini) { panel.innerHTML = '<p class="acr-mini-edit__wait">This item is no longer in your cart.</p>'; return; }
      if (!main || !main.properties) {
        panel.innerHTML = '<p class="acr-mini-edit__wait">The big sign this mini matches isn’t in your cart any more. '
          + '<a href="/products/mini-qr-code-sign">Design the mini yourself →</a></p>';
        return;
      }

      var slots = M.parseSlots(main.properties);
      var curIdx = 1;
      var d = mini.properties.Design || '';
      if (d.indexOf('carries QR ') > -1) {
        curIdx = parseInt(d.split('carries QR ')[1], 10) || 1;
      }
      var isOther = /DIFFERENT from the big sign/i.test(mini.properties['Social Media Links'] || '');
      var curLink = '';
      var lm = (mini.properties['Social Media Links'] || '').match(/link\s*-(?:&gt;|>)\s*(\S+)/i);
      if (isOther && lm) curLink = lm[1];
      var html = '';
      html += '<label class="acr-mini-edit__field"><span>Which QR goes on the mini?</span><select data-acr-mini-qr>';
      slots.forEach(function (s) {
        html += '<option value="' + s.index + '"' + (!isOther && s.index === curIdx ? ' selected' : '') + '>'
          + (slots.length > 1 ? s.index + ') ' : '') + s.name.replace(/[<>]/g, '')
          + (slots.length > 1 ? '' : ' (same as your sign)') + '</option>';
      });
      html += '<option value="other"' + (isOther ? ' selected' : '') + '>Other — a different QR code</option>';
      html += '</select></label>';
      html += '<label class="acr-mini-edit__field" data-acr-mini-linkrow' + (isOther ? '' : ' hidden') + '>'
        + '<span>Link for the mini’s own QR code</span>'
        + '<input type="text" data-acr-mini-qrlink placeholder="Paste the link — or leave blank and we’ll email you" value="'
        + curLink.replace(/"/g, '&quot;') + '"></label>';
      var bottom = mini.properties['Text at the bottom'] || '';
      html += '<label class="acr-mini-edit__field"><span>Text under the QR</span>'
        + '<input type="text" maxlength="40" data-acr-mini-bottom value="' + String(bottom).replace(/"/g, '&quot;') + '"></label>';
      html += '<button type="button" class="acr-mini-edit__save" data-acr-mini-save="' + key + '">Save changes</button>';
      html += '<p class="acr-mini-edit__note">Colour, frame and stand match your big sign. '
        + 'Want a completely different mini? '
        + '<a href="/products/mini-qr-code-sign" data-acr-mini-design="' + (mini.variant_id || '')
        + '" data-acr-mini-mainkey="' + main.key + '" data-acr-mini-key="' + key
        + '">Design it your way →</a></p>';
      panel.innerHTML = html;
      panel._acrMain = main;
      var dlink = panel.querySelector('[data-acr-mini-design]');
      if (dlink) dlink._acrMain = main;   /* tasarimci rengi bundan devralir */
      panel._acrQty = mini.quantity || 1;
      var qsel = panel.querySelector('[data-acr-mini-qr]');
      var lrow = panel.querySelector('[data-acr-mini-linkrow]');
      if (qsel && lrow) {
        qsel.addEventListener('change', function () { lrow.hidden = qsel.value !== 'other'; });
      }
    }, function () {
      panel.innerHTML = '<p class="acr-mini-edit__wait">Couldn’t load your cart. Please refresh.</p>';
    });
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target && evt.target.closest ? evt.target.closest('[data-acr-mini-edit]') : null;
    if (t) {
      evt.preventDefault();
      var wrap = t.closest('.acr-mini-sum');
      var panel = wrap ? wrap.querySelector('[data-acr-mini-panel]') : null;
      if (!panel || !window.AcrMiniProps) return;
      if (!panel.hidden) { panel.hidden = true; t.textContent = 'Change the mini'; return; }
      miniEditor(wrap, panel, t);
      return;
    }

    var sv = evt.target && evt.target.closest ? evt.target.closest('[data-acr-mini-save]') : null;
    if (!sv) return;
    evt.preventDefault();
    var M = window.AcrMiniProps;
    var panel = sv.closest('[data-acr-mini-panel]');
    var main = panel && panel._acrMain;
    if (!M || !main) return;
    var key = sv.getAttribute('data-acr-mini-save');
    var qrEl = panel.querySelector('[data-acr-mini-qr]');
    var btEl = panel.querySelector('[data-acr-mini-bottom]');
    var lkEl = panel.querySelector('[data-acr-mini-qrlink]');
    var other = !!(qrEl && qrEl.value === 'other');
    var props = M.build(main.properties, {
      mainKey: main.key,
      qrIndex: other ? 1 : (qrEl ? (parseInt(qrEl.value, 10) || 1) : 1),
      qrOther: other,
      qrLink: other && lkEl ? lkEl.value : '',
      bottom: btEl ? btEl.value : undefined,
      edited: true
    });
    sv.disabled = true;
    sv.textContent = 'Saving…';
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    fetch(base + '/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: key, quantity: panel._acrQty || 1, properties: props,
        sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        repaint(data && data.sections);
        if (!data || !data.sections) window.location.reload();
      })
      .catch(function () { sv.disabled = false; sv.textContent = 'Save changes'; });
  });

  function boot() {
    enhanceDbump();
    var d = document.getElementById('CartDrawer');
    if (d && window.MutationObserver) {
      new MutationObserver(function () { enhanceDbump(); }).observe(d, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
